'use strict';

// Client-side module for Chronopost pickup modal and Google Maps rendering

let map;
let markers = [];
let infoWindow;

// Cached jQuery elements for the active modal instance
let $modalContainer = null;
let $cityInput = null;
let $postalInput = null;
let $searchBtn = null;
let $widgetContainer = null;
let $locationsResultEl = null;
let $confimationBtnContainerEl = null;
let $listResultsUl = null;
let $mapDiv = null;

const getEl = (selector) => document.querySelector(selector);

const closeModal = () => {
    $('html').removeClass('modal-open');
    $("#chronopost-pickup-container").addClass('hide');
    if ($("input:radio.shipping-method-input:checked").hasClass('chronopost-method') && $('.store-details-chronopostpickup-section .address-line1').is(':empty')) {
        $('.shipping-default .shipping-method-input').trigger('click');
    } else {
        if (localStorage.getItem('storedAddressDataChronopost') != null) {
        const storeData = JSON.parse(localStorage.getItem('storedAddressDataChronopost'));
        const $chronoInput = $('input[name$="_shippingMethodID"].chronopost-method');
        const shippingId = $chronoInput.length ? $chronoInput.val() : null;
        const selectedStoreData = storeData[shippingId];
        if(selectedStoreData){
            $('#pickupStore_storeID').val(selectedStoreData.id || '');
            $('#pickupStore_storeAddress1').val(selectedStoreData.addressLine1 || '');
            $('#pickupStore_storeAddress2').val(selectedStoreData.addressLine2 || '');
            $('#pickupStore_storeAddressPostal').val(selectedStoreData.postcode || '');
            $('#pickupStore_storeAddressCity').val(selectedStoreData.city || '');
            const countryCode = selectedStoreData.country || (window.User && window.User.locale && window.User.locale.split('_').length === 2 ? window.User.locale.split('_')[1] : 'GB');
            $('#pickupStore_storeAddressCountry').val(countryCode);
        }
        
    }
    }
};


// Fetch City Value
const fetchCity = () => {
    let city = "";
    if ($(".address-tile").length > 0) {
        city = $(".address-tile.selected").find(".mini-address-wrapper").data("city");
    } else if ($('.store-chronopostpickup-details').length > 0 && !$(".store-details-chronopostpickup-section .postcode").is(':empty')) {
        city = $('.store-chronopostpickup-details').find('.city').text();
    } else {
        city = $(".input-text.city").val();
    }
    return city;
};

// Fetch Postal Code Value
const fetchPostalCode = () => {
    let postalCode = "";
    if ($(".address-tile").length > 0) {
        postalCode = $(".address-tile.selected").find(".mini-address-wrapper").data("postal-code");
    } else if ($('.store-chronopostpickup-details').length > 0 && !$(".store-details-chronopostpickup-section .postcode").is(':empty')) {
        postalCode = $('.store-chronopostpickup-details').find('.postcode').text();
    } else {
        postalCode = $(".input-text.postal").val();
    }
    return postalCode;
};

const createModal = () => {
    const container = $("#chronopost-pickup-container");
    $('html').addClass('modal-open');
    container.removeClass('hide');

    // Check if modal already exists
    if (container.find('.modal').length > 0) {
        // Modal already exists, just ensure it's visible and return
        return;
    }

    container.html(`
            <div class="modal">
                <header class="modal-header">
                    <h1 class="widget-title">Select a Pickup Point Shop2SHop by Chronopost</h1>
                    <span class="icon-close"></span>
                </header>

                <div class="modal-body">
                    <section class="widget-chronopost-container">
                        <div class="widget-search-info">
                            <div class="postcode-placeholder">
                                <div class="city-field">
                                    <label>City</label>
                                    <input id="city" class="widgetInput" value="${fetchCity()}">
                                </div>

                                <div class="postal-field">
                                    <label>PC</label>
                                    <input id="postalCode" class="widgetInput" value="${fetchPostalCode()}">
                                </div>
                            </div>

                            <button id="widget-search-button" class="widget-search-button">search</button>
                        </div>

                        <div class="locationsResult hide">
                        <div class="results-info-tab-mobile">
                            <div class="list-view active">list</div>
                            <div class="map-view">map</div>
                        </div>
                        <div class="results-container">
                            <div class="list-results" id="list-results">
                                <ul class="list">
                                </ul>


                            </div>
                        </div>

                        <div id="map" style="height: 300px; width: 100%;"></div>
                    </div>

                    <div class="confimation-btn-container hide">
                        <span class="title">Votre Point Relais®: </span>
                        <span id="selected-store-name" class="sub-title"></span>
                        <button class="validate-btn">VALIDATE</button>
                    </div>
                    </section>
                </div>
            </div>

            <div class="modal-overlay"></div>
    `);

    // Cache DOM elements scoped to this modal instance for performance & clarity
    $modalContainer = container;
    $widgetContainer = $modalContainer.find('.widget-chronopost-container');
    $cityInput = $modalContainer.find('#city');
    $postalInput = $modalContainer.find('#postalCode');
    $searchBtn = $modalContainer.find('#widget-search-button');
    $locationsResultEl = $modalContainer.find('.locationsResult');
    $confimationBtnContainerEl = $modalContainer.find('.confimation-btn-container');
    $listResultsUl = $modalContainer.find('#list-results .list');
    $mapDiv = $modalContainer.find('#map');

    // Avoid duplicate bindings on re-open
    $(document).off('click.chronoOverlay');
    $(document).on('click.chronoOverlay', '.modal-overlay, .chronopost-container .icon-close', closeModal);

    $(document).off('click.chronoSearch', '#widget-search-button');
    $(document).on('click.chronoSearch', '#widget-search-button', handleSearch);

    // Remove the error message as soon as one of the inputs is filled
    $cityInput.add($postalInput).off('input.chronoInputs').on('input.chronoInputs', () => {
        const post = ($postalInput.val() || '').trim();
        if (post) {
            $widgetContainer.find('.error').remove();
        }
    });

    ($cityInput.val() != '' && $postalInput.val() != '' ) && $searchBtn.trigger('click');
};

/* =========================
   MAP INIT
========================= */

const makeCallbackNameFromCity = (postalCode) => {
    const base = (postalCode || '').trim().toLowerCase().replace(/[^a-z0-9_]/g, '_') || 'chrono_maps';
    let name = 'cb_' + base;
    if (/^[0-9]/.test(name)) name = '_' + name;
    // append timestamp+random to avoid collisions and ensure uniqueness
    name = `${name}_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    return name;
};


const loadGoogleMaps = (key, cbName) => {
    if (window.google?.maps) return Promise.resolve();

    // derive callback name from #postalCode then #city input when not provided
    if (!cbName) {
        const cityVal = $cityInput && $cityInput.val() ? $cityInput.val().trim() : ($('#city').val() || '').trim();
        const postalVal = $postalInput && $postalInput.val() ? $postalInput.val().trim() : ($('#postalCode').val() || '').trim();
        cbName = makeCallbackNameFromCity(postalVal || cityVal);
    }

    return new Promise((resolve, reject) => {
        if (!key) {
            console.warn('Google Maps API key is missing');
            showMapError('Google Maps API key is missing');
            return reject(new Error('Google Maps API key is missing'));
        }
        const cb = cbName;
        // expose a short-lived global callback for the API to call on load
        window[cb] = () => { console.info('Google Maps api callback fired'); resolve(); delete window[cb]; };
        const s = document.createElement('script');
        // Use the provided key and a proper callback parameter
        const src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&callback=${cb}`;
        s.src = src;
        s.async = true;
        s.defer = true;
        s.onerror = () => { console.warn('Google Maps script failed to load'); showMapError('Failed to load Google Maps script'); reject(new Error('Failed to load Google Maps')); };
        document.head.appendChild(s);
        // Fallback: if neither callback nor error fires, timeout after 8s
        setTimeout(() => {
            if (!(window.google && window.google.maps)) {
                console.warn('Google Maps script load timed out');
                showMapError('Google Maps load timed out');
                reject(new Error('Google Maps load timed out'));
            }
        }, 8000);
    });
};

const initMap = () => {
    const mapEl = document.getElementById('map');
    if (!mapEl) return;
    if (!(window.google && window.google.maps)) {
        // If the maps library is not available, show an inline message
        showMapError('Loading Google Maps');
        return;
    }
    try {
        infoWindow = new google.maps.InfoWindow();
        map = new google.maps.Map(mapEl, {
            center: { lat: 48.8966, lng: 2.2865 },
            zoom: 13
        });
    } catch (e) {
        console.error('initMap failed:', e);
        showMapError('Failed to initialize map');
    }
};

/**
 * Create InfoWindow HTML adapted for Chronopost response shapes.
 * Handles Chronopost `listeHoraireOuverture` and older hour shapes.
 * @param {Object} p - pickup point object
 * @returns {string|string[]}
 */
const parseChronopostHours = (p) => {
    // Simple mapping from listeHoraireOuverture to a Mon..Sun array of strings.
    const days = Array.from({ length: 7 }, () => '');

    if (p && Array.isArray(p.listeHoraireOuverture)) {
        p.listeHoraireOuverture.forEach((entry) => {
            const d = Number(entry.jour);
            if (!d || d < 1 || d > 7) return;

            // Prefer the provided human-readable string; else build from intervals
            if (entry.horairesAsString) {
                days[d - 1] = entry.horairesAsString;
                return;
            }

            const l = entry.listeHoraireOuverture;
            if (l) {
                if (Array.isArray(l)) {
                    days[d - 1] = l
                        .map((i) => (i.debut && i.fin ? `${i.debut}-${i.fin}` : null))
                        .filter(Boolean)
                        .join(' / ');
                } else if (l.debut && l.fin) {
                    days[d - 1] = `${l.debut}-${l.fin}`;
                }
            }
        });

        return days; // Array of 7 strings ('' for closed)
    }
};

const createInfoWindowContent = (p) => {
    const title = p.adresse1 || p.nom || '';
    // const postal = p.codePostal || p.postal || p.zip || '';
    // const addressLine = [p.adresse1, p.adresse2, p.adresse3].filter(Boolean).join(', ') || p.localite || '';

    const hoursArr = parseChronopostHours(p);

    let hoursHtml = '';
    const dayLabels = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    if (hoursArr && hoursArr.length) {
        if (hoursArr.length === 7) {
            hoursHtml = '<table class="opening-hours">' + hoursArr.map((h, idx) => `<tr><td>${dayLabels[idx]}</td><td>${h || '<span class="closed">Closed</span>'}</td></tr>`).join('') + '</table>';
        } else {
            hoursHtml = '<table class="opening-hours">' + hoursArr.map((line) => `<tr><td>${line}</td></tr>`).join('') + '</table>';
        }
    } else {
        hoursHtml = '<div class="opening-hours-text">Opening hours not available</div>';
    }

    return `<div class="chrono-infowindow"><div class="header"><strong>${title}</strong></div><div class="content"><div class="address-line" aria-expanded="true">Opening hours <span class="icon icon-downCarrot"></span></div>${hoursHtml}</div></div>`;
};

const showMapError = (msg) => {
    try {
        const el = document.getElementById('map');
        if (!el) return;
        el.innerHTML = `<div class="map-error" style="padding:18px;color:#333;background:#fff;border-radius:6px;border:1px solid #e6e6e6;font-size:14px">${msg || 'Map failed to load'}</div>`;
    } catch (e) {
        // ignore
    }
};

const clearMarkers = () => {
    markers.forEach((m) => { if (typeof m.setMap === 'function') m.setMap(null); });
    markers = [];
};

/**
 * Create a data-uri SVG marker icon with an optional numeric label.
 * Returns an object suitable for google.maps.Marker.icon
 * @param {string|number} label
 */
const createMarkerIcon = (label) => {
    const lbl = String(label || '');
    const width = 36;
    const height = 44;
    const fontSize = lbl.length > 1 ? 8 : 10;
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
            <path d="M18 3 C11 3 4 9 4 18 C4 30 18 41 18 41 C18 41 32 30 32 18 C32 9 25 3 18 3 Z" fill="#000000"/>
            <circle cx="18" cy="12" r="8" fill="#000" />
            <text x="18" y="18" font-family="Arial, Helvetica, sans-serif" font-size="14px" font-weight="bold" fill="#fff" text-anchor="middle" alignment-baseline="middle">${lbl}</text>
        </svg>`;
    const url = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
    return {
        url,
        scaledSize: new google.maps.Size(width, height),
        anchor: new google.maps.Point(Math.round(width / 2), height)
    };
};

const renderMarkers = (points) => {
    if (!window.google || !window.google.maps) return;
    clearMarkers();

    points.forEach((p, i) => {
        if (!p.lat || !p.lng) return;

        // Use a custom SVG pin with the list index as label
        const marker = new google.maps.Marker({
            map,
            position: { lat: p.lat, lng: p.lng },
            title: p.adresse1 || '',
            icon: createMarkerIcon(i + 1)
        });

        marker._id = p.id || '';
        marker._data = p;

        marker.addListener('click', () => {
            // 1. Open InfoWindow (Existing functionality)
            const content = createInfoWindowContent(p);
            infoWindow.setContent(content);
            infoWindow.open(map, marker);

            // 2. Center and Zoom (Same functionality as onListItemClick)
            map.setZoom(15);
            map.setCenter(marker.getPosition());

            // 3. Find the corresponding list item using the unique ID
            const $li = $listResultsUl.find(`.list-item[data-id="${p.id}"]`);

            if ($li.length) {
                // 4. Manually update UI to match 'onListItemClick' logic
                // We do this manually to avoid an infinite loop of triggers
                $('.list-item').removeClass('selected');
                $li.addClass('selected');

                const adresse1 = $li.data('adresse1') || '';
                $('#selected-store-name').text(adresse1);
                $confimationBtnContainerEl.removeClass('hide');

                // Optional: Scroll the list to the selected item so the user sees it
                // (Useful on mobile or small screens)
                const listContainer = $('#list-results');
                if (listContainer.length) {
                    const scrollTop = $li.position().top + listContainer.scrollTop() - listContainer.offset().top;
                    listContainer.animate({ scrollTop: scrollTop }, 200);
                }
            }
        });

        markers.push(marker);
    });
};

/* =========================
   SEARCH
========================= */
const handleSearch = (e) => {
    e.preventDefault();

    // Basic validation: if postal are empty show error and stop
    const postVal = ($postalInput ? ($postalInput.val() || '') : ($('#postalCode').val() || '')).trim();

    // remove any previous error
    $widgetContainer.find('.error').length && $widgetContainer.find('.error').remove();

    if (!postVal) {
        // show the requested error message, hide results and confirmation container
        $widgetContainer.prepend('<div class="error">A valid Post Code must be provided in order to use thise widget.</div>');
        $locationsResultEl.addClass('hide');
        $confimationBtnContainerEl.addClass('hide');
        return;
    }

    // disable button while searching
    $searchBtn.prop("disabled", true);
    $listResultsUl.html('<li class="loading">Searching…</li>');
    // show results panel immediately
    $locationsResultEl.removeClass('hide');

    $.ajax({
        url: Urls.GetChronoPickupDetails,
        data: {
            city: $cityInput.val(),
            postcode: $postalInput.val(),
            countryCode: $('#dwfrm_singleshipping_shippingAddress_addressFields_country').val(),
        },
        method: 'GET',
        dataType: 'json'
    })
        .done((response) => {
            // Normalize to array
            let points = [];
            if (Array.isArray(response?.listePointRelais)) {
                points = response.listePointRelais;
            } else if (response?.listePointRelais) {
                points = [response.listePointRelais];
            }

            // Map to only the requested fields
            const mapped = points.map((p) => ({
                id: p.identifiant || '',
                adresse1: p.adresse1 || '',
                adresse2: p.adresse2 || '',
                adresse3: p.adresse3 || '',
                codePays: p.codePays || '',
                codePostal: p.codePostal || '',
                localite: p.localite || '',
                nom: p.nom || '',
                listeHoraireOuverture: p.listeHoraireOuverture || null,
                lat: p.coordGeolocalisationLatitude ? parseFloat(p.coordGeolocalisationLatitude) : null,
                lng: p.coordGeolocalisationLongitude ? parseFloat(p.coordGeolocalisationLongitude) : null
            }));

            // Render list
            let html = '';
            if (mapped.length === 0) {
                html = '<li class="empty">No locations found</li>';
            } else {
                html = mapped.map((m, i) => {
                    const idx = i + 1;
                    return `<li class="list-item" data-index="${idx}" data-id="${m.id}" data-adresse1="${m.adresse1 || ''}" data-adresse2="${m.adresse2 || ''}" data-adresse3="${m.adresse3 || ''}" data-codepostal="${m.codePostal || ''}" data-codepays="${m.codePays || ''}" data-localite="${m.localite || ''}" data-nom="${m.nom || ''}" data-lat="${m.lat || ''}" data-lng="${m.lng || ''}">
                                <span class="title"><span class="count">${idx}</span> ${m.adresse1 || ''}</span>
                                <span class="sub-title">${m.localite || ''} ${m.codePostal || ''} - ${m.nom || ''}</span>
                                ${createInfoWindowContent(m)}
                                </li>`;
                }).join('');
            }

            $listResultsUl.html(html);
            $locationsResultEl.removeClass('hide');

            // bind delegated handlers
            bindModalHandlers();

            initMap();

            // render markers (initialize map first if necessary)
            if (mapped.length > 0) {
                if (window.google && window.google.maps) {
                    renderMarkers(mapped);
                    if (mapped[0].lat && mapped[0].lng) {
                        map.setCenter({ lat: mapped[0].lat, lng: mapped[0].lng });
                        map.setZoom(13);
                    }
                } else if (window.GOOGLE_PLACE_KEY) {
                    loadGoogleMaps(window.GOOGLE_PLACE_KEY)
                        .then(() => {
                            initMap();
                            renderMarkers(mapped);
                            if (mapped[0].lat && mapped[0].lng) {
                                map.setCenter({ lat: mapped[0].lat, lng: mapped[0].lng });
                                map.setZoom(13);
                            }
                        })
                        .catch(() => { console.warn('Google Maps failed to load'); });
                }
            }
        })
        .fail(() => {
            $listResultsUl.html('<li class="error">Sorry, something went wrong. Please try again later.</li>');
        })
        .always(() => {
            $searchBtn.prop("disabled", false);
        });
};

/**
 * Validate selected pickup, update visible store block and optionally persist via an endpoint.
 */
const handleValidate = (e) => {
    e && e.preventDefault && e.preventDefault();
    const $selected = $listResultsUl.find('.list-item.selected');
    if (!$selected.length) {
        // nothing selected - be silent
        return;
    }

    const address1 = $selected.data('adresse1') || '';
    const address2 = $selected.data('nom') || '';
    const postcode = $selected.data('codepostal') || '';
    const city = $selected.data('localite') || '';
    const country = $selected.data('codepays') || '';

    // Visible checkout block
    const $display = $('.store-details-chronopostpickup-section');

    if ($display.length) {
        $display.find('.address-line1').text(address1 || '');
        $display.find('.address-line2').text(address2 || '');
        $display.find('.postcode').text(postcode || '');
        $display.find('.city').text(city || '');
        $display.find('.country').text(country || '');
        $display.addClass('filled');
        $('.store-chronopostpickup-details').find('.address-pin-icon').removeClass('hide');

        // mark shipping method as editable and lock the widget radio
        const $chronoInput = $('input[name$="_shippingMethodID"].chronopost-method');
        const $shippingMethod = $chronoInput.length ? $chronoInput.closest('.shipping-method') : null;
        if ($shippingMethod && $shippingMethod.length) {
            $shippingMethod.addClass('edit-btn-active');
            $('.chronopost-method').trigger('click');
            $('.chronopost-method').attr('disabled', 'disabled');
        }
    }

    // Build a consistent store object (compatible with storedAddressDataChronopost used elsewhere)
    const selectedStoreData = {
        id: $selected.data('id') || '',
        addressLine1: address1 || '',
        addressLine2: address2 || '',
        postcode: postcode || '',
        city: city || '',
        country: country || ''
    };

    // Persist under storedAddressDataChronopost keyed by shipping id (RoyalMail-style)
    const $chronoInput = $('input[name$="_shippingMethodID"].chronopost-method');
    const shippingId = $chronoInput.length ? $chronoInput.val() : null;
    let stored = {};
    try {
        stored = localStorage.getItem('storedAddressDataChronopost') ? JSON.parse(localStorage.getItem('storedAddressDataChronopost')) : {};
    } catch (e) { stored = {}; }
    if (shippingId) {
        stored[shippingId] = selectedStoreData;
        localStorage.setItem('storedAddressDataChronopost', JSON.stringify(stored));
        localStorage['chronopost-edit_' + shippingId] = 'active';
    } else {
        // fallback single-key storage for older flows
        localStorage.setItem('selectedChronoStoreData', JSON.stringify(selectedStoreData));
        localStorage.setItem('storedAddressDataChronopost', JSON.stringify(selectedStoreData));
    }

    // Populate hidden pickup inputs (used server-side)
    $('#pickupStore_storeID').val(selectedStoreData.id || '');
    $('#pickupStore_storeAddress1').val(selectedStoreData.addressLine1 || '');
    $('#pickupStore_storeAddress2').val(selectedStoreData.addressLine2 || '');
    $('#pickupStore_storeAddressPostal').val(selectedStoreData.postcode || '');
    $('#pickupStore_storeAddressCity').val(selectedStoreData.city || '');
    // determine countryCode (prefer explicit country, else try locale)
    const countryCode = selectedStoreData.country || (window.User && window.User.locale && window.User.locale.split('_').length === 2 ? window.User.locale.split('_')[1] : 'GB');
    $('#pickupStore_storeAddressCountry').val(countryCode);
};

const updateChronopostShippingAddress = (thisShipping) => {
    const shippingId = thisShipping.attr('value');
    if (!shippingId) return false;

    // prefer chronopost-edit_<shippingId> flag and storedAddressDataChronopost shape used by other pick-up flows
    if (localStorage['chronopost-edit_' + shippingId] && localStorage.getItem('storedAddressDataChronopost') != null) {
        var stored = {};
        try {
            stored = JSON.parse(localStorage.getItem('storedAddressDataChronopost')) || {};
        } catch (e) { stored = {}; }

        var localCollectValues = stored[shippingId] || null;
        if (!localCollectValues) return false;

        // Update checkout UI for Chronopost
        thisShipping.parent().find('.address-line1').text((localCollectValues.addressLine1 || ''));
        thisShipping.parent().find('.address-line2').text(localCollectValues.addressLine2 || '');
        thisShipping.parent().find('.postcode').text(localCollectValues.postcode || '');
        thisShipping.parent().find('.city').text(localCollectValues.city || '');
        thisShipping.parent().find('.country').text(localCollectValues.country || '');
        thisShipping.parent().find('.store-chronopost-details').addClass('active');

        if (!thisShipping.parent().find('.store-details-chronopostpickup-section .postcode').is(':empty')) {
            thisShipping.parent('.shipping-method').addClass('edit-btn-active');
        }

        return true;
    }
    return false;
}

const setPickupStoreValue = (thisShipping) => {
    const shippingId = thisShipping.attr('value');
    if (!shippingId) return false;

    if (localStorage.getItem('storedAddressDataChronopost') != null) {
        const storeData = JSON.parse(localStorage.getItem('storedAddressDataChronopost'));
        const selectedStoreData = storeData[shippingId];

        if(selectedStoreData){
            $('#pickupStore_storeID').val(selectedStoreData.id || '');
            $('#pickupStore_storeAddress1').val(selectedStoreData.addressLine1 || '');
            $('#pickupStore_storeAddress2').val(selectedStoreData.addressLine2 || '');
            $('#pickupStore_storeAddressPostal').val(selectedStoreData.postcode || '');
            $('#pickupStore_storeAddressCity').val(selectedStoreData.city || '');
            const countryCode = selectedStoreData.country || (window.User && window.User.locale && window.User.locale.split('_').length === 2 ? window.User.locale.split('_')[1] : 'GB');
            $('#pickupStore_storeAddressCountry').val(countryCode);
        }
       
    }
}


/* -------------------------
   Delegated handlers (extracted)
   ------------------------- */

/**
 * Click handler for list items.
 * (uses `this` from jQuery event handler)
 */
function onListItemClick() {
    const $li = $(this);
    $('.list-item').removeClass('selected');
    $li.addClass('selected');

    const adresse1 = $li.data('adresse1') || '';
    $('#selected-store-name').text(adresse1);
    $confimationBtnContainerEl.removeClass('hide');

    // center map on selection and trigger marker if available
    const id = $li.data('id');
    const lat = parseFloat($li.data('lat'));
    const lng = parseFloat($li.data('lng'));

    if (window.google && window.google.maps && !Number.isNaN(lat) && !Number.isNaN(lng)) {
        try {
            map.setCenter({ lat, lng });
            map.setZoom(15);
            const m = markers.find((mk) => mk._id === id);
            if (m) google.maps.event.trigger(m, 'click');
        } catch (e) {
            // ignore map errors
        }
    }
}

/**
 * Bind mobile list/map tab controls.
 */
const bindMobileTabs = () => {
    const $tabs = $modalContainer.find('.results-info-tab-mobile');
    $tabs.off('click.chronoList', '.list-view')
        .on('click.chronoList', '.list-view', () => {
            $tabs.find('.list-view').addClass('active');
            $tabs.find('.map-view').removeClass('active');
            $modalContainer.find('.results-container').removeClass('hide');
            $mapDiv.removeClass('show');
        });

    $tabs.off('click.chronoMap', '.map-view')
        .on('click.chronoMap', '.map-view', () => {
            $tabs.find('.map-view').addClass('active');
            $tabs.find('.list-view').removeClass('active');
            $modalContainer.find('.results-container').addClass('hide');
            $mapDiv.addClass('show');

            // ensure map is initialized and resized
            if (window.google && window.google.maps) {
                if (!map) initMap();
                setTimeout(() => {
                    try {
                        google.maps.event.trigger(map, 'resize');
                        if (markers && markers.length) {
                            const pos = markers[0].getPosition?.();
                            if (pos) map.setCenter(pos);
                        }
                    } catch (e) { /* ignore */ }
                }, 50);
            } else if (window.GOOGLE_PLACE_KEY) {
                loadGoogleMaps(window.GOOGLE_PLACE_KEY)
                    .then(() => {
                        initMap();
                        setTimeout(() => { try { google.maps.event.trigger(map, 'resize'); } catch (e) { /* ignore */ } }, 50);
                    })
                    .catch((err) => { console.warn('Google Maps failed to load', err); });
            }
        });
};

/**
 * Toggle opening hours in the list (click or keyboard)
 */
function onToggleOpeningHours(e) {
    e.stopPropagation();
    const $trigger = $(this);
    const $wrapper = $trigger.closest('.content').find('.opening-hours');
    const expanded = $trigger.attr('aria-expanded') === 'true';
    if (expanded) {
        $wrapper.addClass('active');
        $trigger.attr('aria-expanded', 'false').addClass('expanded');
    } else {
        $wrapper.removeClass('active');
        $trigger.attr('aria-expanded', 'true').removeClass('expanded');
    }
}

const bindToggleOpeningHours = () => {
    $modalContainer.off('click.chronoToggle keyup.chronoToggle', '#list-results .chrono-infowindow .address-line');
    $modalContainer.on('click.chronoToggle', '#list-results .chrono-infowindow .address-line', onToggleOpeningHours)
        .on('keyup.chronoToggle', '#list-results .chrono-infowindow .address-line', function (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); $(this).trigger('click.chronoToggle'); }
        });
};

/**
 * Bind all modal handlers after results are rendered.
 */
const bindModalHandlers = () => {
    // List item click
    $modalContainer.off('click.chronoItem', '.list-item').on('click.chronoItem', '.list-item', onListItemClick);

    // Mobile tabs
    bindMobileTabs();

    // Opening hours toggle
    bindToggleOpeningHours();

    // Confirmation & validate
    $confimationBtnContainerEl.off('click.chronoConfirm').on('click.chronoConfirm', () => closeModal());
    $confimationBtnContainerEl.off('click.chronoValidate', '.validate-btn').on('click.chronoValidate', '.validate-btn', handleValidate);
};


export default {
    init: function () {
        createModal();
    },
    updateChronopostShippingAddress,
    setPickupStoreValue
}

// Export helper so other modules 
export { updateChronopostShippingAddress, setPickupStoreValue };
